import React from "react";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import {Checkbox} from "primereact/checkbox";
import ContextMenu from "../../../components/contextMenu";
import {Dropdown} from "primereact/dropdown";
import HeaderScreenPresval from "../../../components/headerScreenPresval";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const DoneLoansView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <HeaderScreenPresval headerTitle="Reportes \ Diarios \ Préstamos Vigentes"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.getDataReport}
                                             disabledSearchButton = {props.disabledSearchButton}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Actuando como" isBold={true}/>
                                    <Dropdown name="rolObj"
                                              options={props.roles}
                                              filterBy="rolStr"
                                              optionLabel="rolStr"
                                              onChange={props.onChangeFilters}
                                              value={props.filters.rolObj}/>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Mostrar columna" isBold={true}/>
                                    <Typography variant="subtitle2" gutterBottom style={{fontWeight: "bolder"}}
                                                className={"secondary-text"}>
                                        <Checkbox name="isinColumn"
                                                  checked={props.filters.isinColumn}
                                                  onChange={props.onChangeFilters}/>
                                        &nbsp; ISIN
                                    </Typography>
                                </div>
                                <div className="p-col-12 p-md-6 p-col-6">
                                    <br/>
                                    <Button label="Limpiar"
                                            style={{'float': 'right'}}
                                            onClick={props.clearFilters}
                                            className="p-button-secondary"/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>

                    <Grid item xs={12} style={{textAlign: 'right'}}>
                        <ContextMenu menuOptions={props.exportOptions}
                                     isButton={true}
                                     label="Exportar"/>
                    </Grid>

                    <Grid item xs={12}>
                        <DataTable
                            ref={props.reportsTable}
                            value={props.dataReport}
                            scrollable={true}
                            expandedRows={props.expandedRows}
                            rowExpansionTemplate={props.rowExpansionTemplate}
                            rowGroupMode="subheader" sortField="rol" sortOrder={1} groupField="rol"
                            rowGroupHeaderTemplate={props.rowGroupHeaderTemplate}
                            rowGroupFooterTemplate={() => {
                                return ""
                            }}
                            style={{width: '100%'}}
                            resizableColumns={true}
                            columnResizeMode={"fit"}
                            scrollHeight="600px"
                        >
                            {props.columns}
                        </DataTable>
                    </Grid>
                    {props.confMsg}
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default DoneLoansView;